import React, { Component, createRef, useEffect, useState } from "react";
import filter from "../../../images/filter.svg";
import edit from "../../../images/edit.svg";
import search from "../../../images/search.svg";
import { getSessionStorageValue } from "../../../../effects/utils/session-storage";

function MergedContactDetailsComponent(props: any) {
  const { contact_Data } = props
  const [loggedInRole, setLoggedInRole] = useState("");
  useEffect(() => {
    const user: any = getSessionStorageValue("user");
    const userInfo = JSON.parse(user);
    setLoggedInRole(userInfo.roles);
    window.scrollTo(0, 0);
    // console.log(contact_Data[0].representative_name);
  }, []);

  return (
    <div>
      <div className="row left-align mt-05">
        <div className="col-md-4">
          <span className="incubator-label">Name of the Representative</span>
          <br />
          <span className="incubator-label-value">
            {contact_Data[0].representative_name == '' ||
              contact_Data[0].representative_name == null
              ? '-'
              : contact_Data[0].representative_name}
          </span>
        </div>
        <div className="col-md-4">
          <span className="incubator-label">Designation</span>
          <br />
          <span className="incubator-label-value">
            {contact_Data[0].representative_designation == '' ||
              contact_Data[0].representative_designation == null
              ? '-'
              : contact_Data[0].representative_designation}
          </span>
        </div>
      </div>

      <div className="row left-align mt-05">
        <div className="col-md-4">
          <span className="incubator-label">Mobile No.</span>
          <br />
          <span className="incubator-label-value">
            {contact_Data[0].representative_mobile_no == null ||
            contact_Data[0].representative_mobile_no == null
              ? '-'
              : contact_Data[0].representative_mobile_no}
          </span>
        </div>
        <div className="col-md-4">
          <span className="incubator-label">Email</span>
          <br />

          {contact_Data[0].representative_email == '' ||
          contact_Data[0].representative_email == null ? (
            '-'
          ) : (
            <a
              className="incubator-email-value"
              href={`mailto:${contact_Data[0].representative_email}`}
            >
              {contact_Data[0].representative_email}
            </a>
          )}
        </div>
      </div>

      <div className="row left-align mt-05">
        <div className="col-md-4">
          <span className="label-lh-28">Incubator Address</span>
          <br />
          <span className="value-lh-20">
            {contact_Data[0].address == '' ||
            contact_Data[0].address == null
              ? '-'
              : contact_Data[0].address}
          </span>
        </div>
        <div className="col-md-4"></div>
      </div>

      <div className="row left-align">
        <div className="col-md-4"></div>
        <div className="col-md-4"></div>
      </div>
    </div>
  )
}
export default MergedContactDetailsComponent;